import "../../scss/cms.scss";
import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import { initCarousels } from "../modules/product-collection";
import { initShowMoreContent } from "../modules/show-more-content";

async function initCmsPage() {
  await initTranslation();
  initPage();
  initCarousels();
  initShowMoreContent();
}

initCmsPage();
